import { ALL_CHART_TYPES } from "constants/chart.constants";
import { createMergeWithDefaults } from "entities/utils";
import { RateDateChartRequestType, RateDateChartSettings } from "types";

import { BASE_RATE_CHART_SETTINGS, BASE_RATE_REQUEST } from "./baseRateRequest";

export const DEFAULT_RATE_DATE_CHART_SETTINGS: Partial<RateDateChartSettings> = {
  ...BASE_RATE_CHART_SETTINGS,
  chartType: ALL_CHART_TYPES.RateDate.id,
  annotationSettings: {
    showAnnotations: false
  }
};

export const DEFAULT_RATE_DATE_REQUEST: Partial<RateDateChartRequestType> = {
  ...BASE_RATE_REQUEST,
  chartSetting: DEFAULT_RATE_DATE_CHART_SETTINGS as RateDateChartSettings
};

export const generateRateDateRequestBody = createMergeWithDefaults(
  DEFAULT_RATE_DATE_REQUEST
);
